import PropTypes from 'prop-types';
import React from 'react';
import { Trans as I18nextTrans } from 'react-i18next';
import styles from './rich-trans.module.scss';

export const richTransBasicComponents = {
    strong: <strong />,
    b: <strong />,
    em: <em />,
    i: <i />,
    a: <a />,
    br: <br />,
    p: <p />,
    ul: <ul />,
    ol: <ol />,
    li: <li />,
    h1: <h1 />,
    h2: <h2 />,
    h3: <h3 />,
    h4: <h4 />,
    h5: <h5 />,
    h6: <h6 />,
}

const RichTrans = ({
    as: Component = 'span',
    className,
    components = {},
    defaults,
    i18nKey,
    preserveWhitespace = false,
    style,
    values,
}) => {
    const content = (
        <I18nextTrans
            i18nKey={i18nKey}
            defaults={defaults}
            values={values}
            components={{ ...richTransBasicComponents, ...components }}
        />
    )

    if (!Component) {
        return content
    }

    return (
        <Component
            className={[styles.richTrans, className].filter(Boolean).join(' ')}
            style={{
                ...(preserveWhitespace ? { whiteSpace: 'pre-line' } : {}),
                ...style,
            }}
        >
            {content}
        </Component>
    )
}

RichTrans.propTypes = {
    as: PropTypes.elementType,
    className: PropTypes.string,
    components: PropTypes.object,
    defaults: PropTypes.string,
    i18nKey: PropTypes.string,
    preserveWhitespace: PropTypes.bool,
    style: PropTypes.object,
    values: PropTypes.object,
}

export default RichTrans;
